const header__burger = document.querySelector('.header__burger');
const header__menu = document.querySelector('.header__menu');

document.addEventListener("DOMContentLoaded", function(event) {
    let main_menu = document.getElementById('menu-main-menu');
    if(!!main_menu) {
        let list = main_menu.querySelectorAll('.menu-item-has-children');
        if(!!list) {
            list.forEach((el) => {
                let arrow = document.createElement("div");
                arrow.classList.add('menu-main__arrow');
                el.querySelector('.sub-menu').before(arrow);
            })
        }
        document.addEventListener('click', function (e) {
            let el = e.target;
            if(el.classList.contains('menu-main__arrow')) {
                el.parentNode.classList.toggle('active');
            }
        })
    }
    if (header__burger) {
        header__burger.addEventListener('click', () => {
            if (header__burger.classList.contains('header__burger_active')) {
                header__burger.classList.remove('header__burger_active');
                header__menu.classList.remove('header__menu_active');
            } else {
                header__burger.classList.add('header__burger_active');
                header__menu.classList.add('header__menu_active');
            }
        });
    }
})
